import React from 'react';
import { IconsPros } from './types';

/**
 * Text Icon component
 *
 * @returns JSX.ELEMENT
 */
export const TextIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M10.42,6.64l-.2-1.15A.26.26,0,0,0,10,5.26,3.48,3.48,0,0,0,9.1,5.2l0,5.63.91,0c0,.33,0,.68,0,1H6c0-.35,0-.69,0-1l.86,0a0,0,0,0,0,0,0V5.19a5.84,5.84,0,0,0-.87.06c-.18,0-.21.12-.24.24L5.59,6.64c-.45,0-.94-.06-1.34-.11.05-.81.1-1.63.17-2.43h7.25c.05.8.1,1.62.13,2.42C11.35,6.57,10.87,6.6,10.42,6.64Zm3-6.64H2.56A2.5,2.5,0,0,0,0,2.44V13.56A2.5,2.5,0,0,0,2.56,16H13.44A2.5,2.5,0,0,0,16,13.56V2.44A2.51,2.51,0,0,0,13.44,0Z" />
    </svg>
  );
};
